import React, { useEffect, useState } from "react";
import "../promotersPages.scss";
import AuthClient from "../../../api/AuthClient";
import AcceptedApi from "../../../api/AcceptedApi";
import { parseMyPartyResponse } from "../../../api/parseResponse/parseMyPartiesResponse";
import { PartyModel } from "../../../types";
import RefreshButton from "../../RefreshToUpdateData/RefreshToUpdateButton";
import AcceptedGroupDetail from "./AcceptedGroupDetail";

interface Props {
  authClient: AuthClient;
}

const Accepted: React.FC<Props> = ({ authClient }) => {
  const [acceptedGroups, setAcceptedGroups] = useState<PartyModel[] | undefined>();
  const [refreshRequest, setRefreshRequest] = useState(false);
  const [requeststate, setRequestState] = useState('idle');

  useEffect(() => {
    setRequestState('loading');
    const fetchGroups = async () => {
      const myParties = new AcceptedApi(authClient);

      try {
        const response = await myParties.getMyParties();
        if (response) {
          const fetchedGroups = response.data?.map(parseMyPartyResponse);
          setAcceptedGroups(fetchedGroups);

          setTimeout(() => {
            setRequestState('success');
          }, 4000);

          if (fetchedGroups?.length === 0) {
            console.log("Returned data is empty");
          }
        }
      } catch (err) {
        console.error("Error fetching groups:", err);
      }
    };

    fetchGroups();
    setRefreshRequest(false);

  }, [refreshRequest]);

  if (acceptedGroups === null) {
    return null;
  }

  const handleButtonClick = () => {
    setRefreshRequest(true)
  };

  return (
    <>
      <div className="mb-3 refreshRequestContainer">
        <RefreshButton requestState={requeststate} onClickHandler={handleButtonClick} />
      </div>

      {acceptedGroups && acceptedGroups.length > 0 ? (
        <div>
          {acceptedGroups?.map((group: PartyModel) => (
            <AcceptedGroupDetail group={group} />
          ))}
        </div>
      ) : (
        <div className="m-4 p-4 text-white text-center">No groups</div>
      )}
    </>
  );
};

export default Accepted;
